export { sv } from '@payloadcms/translations/languages/sv'
